import { EmptyAssetIdError, EmptyFileIdError } from '../../errors';
import { unwrapFileUploadKind } from '../../state/upload_kind';
import type { EntitiesLifecycleContext } from './entities_lifecycle';

/**
 * The asset the upload belongs to. Every lifecycle needs it, and by the time
 * one runs it is always set: a new asset has been created, and the other
 * targets carry the id they were queued with.
 */
export function unwrapAssetId<Meta, ChunkMeta>(
  context: EntitiesLifecycleContext<Meta, ChunkMeta>,
): string {
  const assetId = context.getState().target.assetId;
  if (!assetId) {
    throw new EmptyAssetIdError('Asset ID is not set');
  }
  return assetId;
}

/**
 * The file entity the bytes were written into. Only the file lifecycle has one;
 * a proxy keeps its id in the upload kind, reached through
 * unwrapUploadEntityId instead.
 */
export function unwrapFileId<Meta, ChunkMeta>(
  context: EntitiesLifecycleContext<Meta, ChunkMeta>,
): string {
  const fileId = unwrapFileUploadKind(context.getState()).fileId;
  if (!fileId) {
    throw new EmptyFileIdError('File ID is not set');
  }
  return fileId;
}
